import api from '../../../../api.js'
import {handleResponseErrors} from '../../../services/processServerErrors.js'

export default async function upload(values, fetchConf) {
  return api.users.uploadImage(values, fetchConf).catch(handleResponseErrors)
}